export { default } from './DataMode';
